<template>
    <div id="service">
        <div class="mx-2 pt-10 lg:pt-0 lg:px-40 lg:pb-20">
            <div class="text-left grid justify-items-center gap-4 lg:px-15">
                <div class="mb-10">
                    <img src="@/assets/rekomcc.png" alt="catra" class="lg:w-[950px] mx-auto" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "@/assets/tailwind.css";

export default {

}
</script>

<style></style>